import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "facebook",
  "use": "facebook-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"facebook\"><g fill=\"none\" fill-rule=\"evenodd\"><path fill=\"#3B5998\" d=\"M11.972 0c6.612 0 11.972 5.36 11.972 11.972 0 6.612-5.36 11.972-11.972 11.972C5.36 23.944 0 18.584 0 11.972 0 5.36 5.36 0 11.972 0z\" /><path fill=\"#FFF\" d=\"M13.43 8.242h1.543v-2.28h-1.814v.009c-2.198.078-2.648 1.313-2.688 2.61h-.004V9.72H8.97v2.232h1.497v5.983h2.255v-5.983h1.847l.357-2.232h-2.203v-.688c0-.438.291-.79.707-.79z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol